import type { SVGProps } from 'react';

export const LightningBolt = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      preserveAspectRatio="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        d="m2.23 14.4q-0.36 0-0.66-0.18-0.3-0.19-0.45-0.5-0.15-0.32-0.11-0.66 0.04-0.35 0.26-0.62l12.1-12.23q0.14-0.16 0.35-0.2 0.21-0.04 0.4 0.06 0.19 0.1 0.27 0.29 0.08 0.2 0.03 0.4l-2.35 7.22q-0.1 0.28-0.06 0.57 0.03 0.29 0.21 0.54 0.17 0.24 0.43 0.38 0.27 0.13 0.57 0.13h8.55q0.36 0 0.66 0.18 0.3 0.19 0.45 0.5 0.15 0.32 0.11 0.66-0.04 0.35-0.26 0.62l-12.1 12.23q-0.14 0.16-0.35 0.2-0.21 0.04-0.4-0.06-0.19-0.1-0.27-0.29-0.08-0.2-0.03-0.4l2.35-7.22q0.1-0.28 0.06-0.57-0.03-0.29-0.21-0.54-0.17-0.24-0.43-0.38-0.27-0.13-0.57-0.13z"
        fill="currentColor"
      />
    </svg>
  );
};
